import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'

import UnauthorizedPage from '../index'
import CheckYourInbox from './CheckYourInbox'
import Form from '../../../components/Form'
import Field from '../../../components/Form/Field'
import InfoBlock from '../../../features/components/InfoBlock'

import { EMAIL, initialValues, validationSchema } from './fields'

import { resendRegister } from '../../../modules/actions/auth'
import { resendRegisterErrorSelector, resendRegisterLoadingSelector } from '../../../modules/selectors/auth'

import useAuthStyles from '../../../styles/common/authPages'

const ResendRegister = () => {
  const authClasses = useAuthStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [formSubmitted, setFormSubmitted] = useState(false)

  const onSubmit = values => {
    dispatch(resendRegister(values))
    setFormSubmitted(true)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })

  const onResendEmail = () => {
    const { email } = formik.values
    dispatch(resendRegister({ email }, true))
  }

  return (
    <UnauthorizedPage helmetTitle="Resend Register" className={authClasses.authPage}>
      {formSubmitted ? (
        <CheckYourInbox onResendEmail={onResendEmail} email={formik.values.email} />
      ) : (
        <>
          <InfoBlock title={t('Sorry, that link has expired')}>
            {t('Fear not, we can resend you a new one. Please enter the email address that you registered with:')}
          </InfoBlock>
          <div className={authClasses.formContainer}>
            <Form
              formik={formik}
              method="post"
              successSubmit={formSubmitted}
              errorSelector={resendRegisterErrorSelector}
              isLoadingSelector={resendRegisterLoadingSelector}
              submitText={t('Send New Link')}
            >
              <Field formik={formik} id={EMAIL} name={EMAIL} placeholder={t('Registered Email')} />
            </Form>
          </div>
        </>
      )}
    </UnauthorizedPage>
  )
}

export default ResendRegister
